import React from 'react';

// Animation on Scroll
import Zoom from 'react-reveal/Zoom';

// Local imports
import AboutFlexibilityCard from './AboutFlexibilityCard';
import AboutStandardsCard from './AboutStandardsCard';
import AboutExperienceCard from './AboutExperienceCard';

const AboutContent = () => {
	return (
		<div>
			<Zoom>
				<AboutFlexibilityCard />
			</Zoom>
			<Zoom>
				<AboutStandardsCard />
			</Zoom>
			<Zoom>
				<AboutExperienceCard />
			</Zoom>
		</div>
	);
};

export default AboutContent;
